import React, { useState } from 'react';
import EmailMarketingDashboard from './EmailMarketingDashboard';
import EmailCampaignDashboard from './EmailCampaignDashboard';
import EmailContactsManager from './EmailContactsManager';
import UnsubscribeManager from './UnsubscribeManager';
import StateAdminDashboard from './StateAdminDashboard';
import AdminNavigation from './AdminNavigation';
import '../AdminDashboard.css';

const AdminDashboard: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'dashboard' | 'email' | 'campaigns' | 'unsubscribe' | 'contacts' | 'states' | 'users' | 'settings'>('campaigns');

    return (
        <div className="admin-dashboard-container">
            {/* Admin Navigation Tabs */}
            <AdminNavigation activeTab={activeTab} onTabChange={setActiveTab} />

            {/* Tab Content */}
            <div className="admin-tab-content">
                {activeTab === 'dashboard' && (
                    <div className="admin-section">
                        <h1>System Admin Dashboard</h1>
                        <p>Welcome to the AngelWatch administrative control panel.</p>
                        <div className="admin-quick-stats">
                            <div className="quick-stat-card">
                                <h3>Total Users</h3>
                                <p className="stat-number">1,247</p>
                                <span className="stat-label">Active accounts</span>
                            </div>
                            <div className="quick-stat-card">
                                <h3>Total Schools</h3>
                                <p className="stat-number">89</p>
                                <span className="stat-label">Registered schools</span>
                            </div>
                            <div className="quick-stat-card">
                                <h3>Certificates Issued</h3>
                                <p className="stat-number">3,421</p>
                                <span className="stat-label">This month</span>
                            </div>
                            <div className="quick-stat-card">
                                <h3>System Status</h3>
                                <p className="stat-badge badge-success">✅ Operational</p>
                                <span className="stat-label">All systems normal</span>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'email' && (
                    <EmailMarketingDashboard />
                )}

                {activeTab === 'campaigns' && (
                    <EmailCampaignDashboard />
                )}

                {activeTab === 'unsubscribe' && (
                    <UnsubscribeManager />
                )}

                {activeTab === 'contacts' && (
                    <EmailContactsManager />
                )}

                {activeTab === 'states' && (
                    <StateAdminDashboard />
                )}

                {activeTab === 'users' && (
                    <div className="admin-section">
                        <h1>User Management</h1>
                        <p>Manage all users across the platform.</p>
                        <div className="coming-soon-message">
                            <span className="coming-soon-icon">🚧</span>
                            <h3>Coming Soon</h3>
                            <p>User management features are currently under development.</p>
                        </div>
                    </div>
                )}

                {activeTab === 'settings' && (
                    <div className="admin-section">
                        <h1>System Settings</h1>
                        <p>Configure system-wide settings and preferences.</p>
                        <div className="coming-soon-message">
                            <span className="coming-soon-icon">🚧</span>
                            <h3>Coming Soon</h3>
                            <p>Settings panel is currently under development.</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminDashboard;
